import styled from 'styled-components';

export const OutsideShape = styled.path`
  color: ${({ theme }) => theme.colors.accent};
`;

export const InsideShape = styled.path`
  color: ${({ theme }) => theme.colors.primary};
`;
